import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const CatalogoPage = lazy(() => import('../pages/catalogo/page'));
const ProductoPage = lazy(() => import('../pages/producto/page'));
const VendedorPage = lazy(() => import('../pages/vendedor/page'));
const AutosPage = lazy(() => import('../pages/autos/page'));
const RepresentantesPage = lazy(() => import('../pages/representantes/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const RegistroPage = lazy(() => import('../pages/registro/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const ConfirmacionPage = lazy(() => import('../pages/confirmacion/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminPortalPage = lazy(() => import('../pages/admin-portal/page'));
const SubastasPage = lazy(() => import('../pages/subastas/page'));
const BienesRaicesPage = lazy(() => import('../pages/bienes-raices/page'));
const GanastePage = lazy(() => import('../pages/ganaste/page'));
const MisComprasPage = lazy(() => import('../pages/mis-compras/page'));
const RecuperarContrasenaPage = lazy(() => import('../pages/recuperar-contrasena/page'));
const NuevaContrasenaPage = lazy(() => import('../pages/nueva-contrasena/page'));
const TerminosPage = lazy(() => import('../pages/terminos/page'));
const PrivacidadPage = lazy(() => import('../pages/privacidad/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/catalogo',
    element: <CatalogoPage />,
  },
  {
    path: '/producto/:id',
    element: <ProductoPage />,
  },
  {
    path: '/vendedor/:id',
    element: <VendedorPage />,
  },
  {
    path: '/autos',
    element: <AutosPage />,
  },
  {
    path: '/representantes',
    element: <RepresentantesPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/registro',
    element: <RegistroPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/confirmacion',
    element: <ConfirmacionPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/admin-portal',
    element: <AdminPortalPage />,
  },
  {
    path: '/subastas',
    element: <SubastasPage />,
  },
  {
    path: '/bienes-raices',
    element: <BienesRaicesPage />,
  },
  {
    path: '/ganaste',
    element: <GanastePage />,
  },
  {
    path: '/mis-compras',
    element: <MisComprasPage />,
  },
  {
    path: '/recuperar-contrasena',
    element: <RecuperarContrasenaPage />,
  },
  {
    path: '/nueva-contrasena',
    element: <NuevaContrasenaPage />,
  },
  {
    path: '/terminos',
    element: <TerminosPage />,
  },
  {
    path: '/privacidad',
    element: <PrivacidadPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;